// extracted by mini-css-extract-plugin
export var readonly = "_ep-1";
export var star = "_ep-0";